import React, { useEffect, useState } from 'react'
import {
    BarChart,
    Bar,
    ResponsiveContainer,
    CartesianGrid,
    Tooltip,
    XAxis,
    YAxis,
    Cell
} from 'recharts';
import { filterUsers } from '../../utils/Network';

function DashboardBarChart() {
    const [users, setUsers] = useState(null);
    const MALE_COLOR = '#4ca5ff';
    const FEMALE_COLOR = '#f6a900';

    useEffect(() => {
        filterUsers("&is_verified=1&size=70000000", 1).then((data) => {
            if (data.results) setUsers(data.results);
        });
    }, [])

    const _countUsers = (country, gender) => {
        if (!users) return 0;
        const count = users.filter((obj) => obj.country === country && obj.gender === gender).length;
        return count;

    }


    const data = [
        {
            name: 'Rojhelat', male: _countUsers(247,0), female: _countUsers(247,1),
        },
        {
            name: 'Basur', male: _countUsers(249,0), female: _countUsers(249,1),
        },
        {
            name: 'Bakur', male: _countUsers(245,0), female: _countUsers(245,1),
        },
        {
            name: 'Rojawa', male: _countUsers(248,0), female: _countUsers(248,1),
        },
        
        
        
    ];
    const CustomTooltip = ({ active, payload, label }) => {
        if (!active || !payload || !payload.length) return null;
        const male = payload.find((item) => item.dataKey === 'male')?.value ?? 0;
        const female = payload.find((item) => item.dataKey === 'female')?.value ?? 0;
        const total = male + female;

        return (
            <div style={{
                background: '#121a23',
                border: '1px solid #2f3f52',
                borderRadius: '10px',
                padding: '10px 12px',
                color: '#d6e2ef',
                boxShadow: '0 8px 24px rgba(0,0,0,0.35)'
            }}>
                <div style={{ fontWeight: 700, marginBottom: '6px', color: '#ffffff' }}>{label}</div>
                <div style={{ fontSize: '12px', marginBottom: '2px' }}>
                    <span style={{ color: MALE_COLOR }}>Male:</span> {male.toLocaleString()}
                </div>
                <div style={{ fontSize: '12px', marginBottom: '2px' }}>
                    <span style={{ color: FEMALE_COLOR }}>Female:</span> {female.toLocaleString()}
                </div>
                <div style={{ fontSize: '12px', opacity: 0.9 }}>
                    Total: {total.toLocaleString()}
                </div>
            </div>
        );
    };

    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart
                data={data}
                barCategoryGap={26}
                margin={{
                    top: 8, right: 12, left: 4, bottom: 2,
                }}
            >
                <CartesianGrid strokeDasharray="3 6" stroke="rgba(176, 199, 224, 0.18)" />
                <XAxis
                    dataKey="name"
                    tick={{ fill: '#b7c7d8', fontSize: 12, fontWeight: 600 }}
                    axisLine={{ stroke: '#2f4052' }}
                    tickLine={false}
                />
                <YAxis
                    tick={{ fill: '#9bb0c6', fontSize: 12 }}
                    axisLine={{ stroke: '#2f4052' }}
                    tickLine={false}
                    allowDecimals={false}
                />
                <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.05)' }} />
                <Bar dataKey="male" radius={[8, 8, 0, 0]}>
                    {data.map((entry) => (
                        <Cell key={`male-${entry.name}`} fill={MALE_COLOR} />
                    ))}
                </Bar>
                <Bar dataKey="female" radius={[8, 8, 0, 0]}>
                    {data.map((entry) => (
                        <Cell key={`female-${entry.name}`} fill={FEMALE_COLOR} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}

export default DashboardBarChart